<template>
  <div v-if="selectedOutcome && currentUserData" :style="cssVars">
    <div class="q-pa-none">
      <div class="row full-width">
        <div style="width: 75%">
          <div class="q-pa-none">
            <div class="row full-width">
              <div style="width: 100%">
                <topbar
                  :title="
                    currentUserData.sustainabilityBusiness_name
                      ? currentUserData.sustainabilityBusiness_name
                      : 'Test Business'
                  "
                  :titleColor="cssVars['--outcome-secondary']"
                  :backgroundColor="cssVars['--outcome-primary']"
                >
                  <template v-slot:content>
                    <div class="row">
                      <div class="col">
                        <div class="row">
                          <span
                            class="title"
                            :style="`color: ${cssVars['--outcome-secondary']} `"
                          >
                            {{
                              currentUserData.sustainabilityBusiness_name
                                ? currentUserData.sustainabilityBusiness_name
                                : "Test Business"
                            }}
                          </span>
                        </div>
                        <div class="row justify-between">
                          <div class="row items-center q-mt-xs">
                            <span class="dropdownTitle text-white q-mr-md">
                              Setting Goals for
                            </span>
                            <sustainability-dropdown
                              :model="selectedOutcome"
                              class="q-ml-sm"
                              :style="`
                      background-color: ${cssVars['--outcome-secondary']};
                      border-radius: 5px;
                      `"
                              :options="outcomesList"
                              :isObjects="true"
                              objectKey="label"
                              @input="selectOutcome"
                            ></sustainability-dropdown>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="selectedOutcome.usesFactor == 1"
                        class="col-auto"
                        style="
                          position: relative;
                          min-width: 260px;
                          max-width: 260px;
                        "
                      >
                        <summary-stats-card
                          style="position: absolute; top: -17px; right: -17px"
                          :bg="cssVars['--outcome-secondary']"
                          :slides="summaryStatsCardSlides"
                          @setOverallTarget="setOverallTarget"
                        ></summary-stats-card>
                      </div>
                    </div>
                  </template>
                </topbar>
              </div>
            </div>
          </div>
          <div class="q-px-md q-mt-sm">
            <div class="row">
              <div class="col-12">
                <div class="row justify-between items-center">
                  <div>
                    <q-btn
                      class="q-ml-lg"
                      icon="mdi-dots-vertical"
                      flat
                      color="black"
                      padding="0px"
                    >
                      <q-menu>
                        <q-list style="min-width: 100px">
                          <q-item
                            :disable="selectedGoalIndex == null"
                            @click="updateSelectedGoal(null)"
                            clickable
                            v-close-popup
                          >
                            <q-item-section>Edit Selected Goal</q-item-section>
                          </q-item>
                          <q-item
                            :disable="selectedGoalIndex == null"
                            @click="deleteSelectedGoal()"
                            clickable
                            v-close-popup
                          >
                            <q-item-section
                              >Delete Selected Goal</q-item-section
                            >
                          </q-item>
                        </q-list>
                      </q-menu>
                    </q-btn>
                  </div>
                  <div>
                    <div class="row items-center">
                      <q-btn
                        flat
                        @click="grid = true"
                        icon="mdi-view-grid"
                        :color="grid ? 'primary' : 'grey'"
                        no-caps
                      >
                        <span class="q-mx-sm text-grey gridOptions_text">
                          Grid
                        </span>
                      </q-btn>
                      <q-btn
                        flat
                        @click="grid = false"
                        icon="mdi-format-list-checkbox"
                        :color="grid ? 'grey' : 'primary'"
                        no-caps
                      >
                        <span class="q-mx-sm text-black gridOptions_text">
                          List
                        </span>
                      </q-btn>

                      <div class="float-right">
                        <span class="gridOptions_text q-mr-sm"> Sort By </span>
                        <q-select
                          class=""
                          style="display: inline-block; width: 160px"
                          dense
                          v-model="sortByDropdown"
                          :options="sortByDropdownOptions"
                          filled
                          @input="filterGoals"
                        ></q-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row q-mt-xs">
              <!--LIST VIEW-->
              <q-virtual-scroll
                v-if="!grid"
                style="height: calc(100vh - 285px)"
                class="full-width q-pb-md"
                :items="formattedGoals"
              >
                <template v-slot="{ item, index }">
                  <q-card
                    flat
                    :style="`background-color: ${
                      index % 2 == 0 ? '#f7f7f7' : 'white'
                    }`"
                  >
                    <q-item
                      v-if="item.basicGoals_id"
                      :key="index"
                      dense
                      clickable
                      v-ripple="{ color: 'primary' }"
                      @click="selectGoal(item, index)"
                      class="q-mb-xs"
                    >
                      <q-item-section side>
                        <q-checkbox
                          v-model="item.selected"
                          @input="selectGoal(item, index)"
                          color="accent"
                        >
                        </q-checkbox>
                      </q-item-section>
                      <q-item-section>
                        <q-item-label class="goalItem_text">
                          <span
                            v-if="formatPreWrittenGoalText(item).reversed"
                            class="goalItem_source_text text-bold"
                          >
                            {{ formatPreWrittenGoalText(item).coloredText }}
                          </span>
                          {{ formatPreWrittenGoalText(item).normalText }}
                          <span
                            v-if="!formatPreWrittenGoalText(item).reversed"
                            class="goalItem_source_text text-bold"
                          >
                            {{ formatPreWrittenGoalText(item).coloredText }}
                          </span>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                    <q-item
                      v-else
                      dense
                      clickable
                      v-ripple="{ color: 'primary' }"
                      class="q-mb-xs"
                      @click="selectGoal(item, index)"
                    >
                      <q-item-section side>
                        <q-checkbox
                          v-model="item.selected"
                          @input="selectGoal(item, index)"
                          color="accent"
                        >
                        </q-checkbox>
                      </q-item-section>
                      <q-item-section v-if="item.writeYourOwnGoal">
                        <q-item-label class="goalItem_text">
                          <span class="goalItem_source_text text-bold">
                            {{ item.writeYourOwnGoal }}
                          </span>
                        </q-item-label>
                      </q-item-section>
                      <q-item-section v-else>
                        <q-item-label class="goalItem_text">
                          {{
                            item.action == "Reduce" ? "Reduction" : "Increase"
                          }}
                          of
                          <span class="goalItem_source_text text-bold">
                            {{ item.sourceData.name }}
                          </span>
                          by
                          <span class="goalItem_source_text text-bold">
                            {{
                              (item.baselineData * item.reductionPercentage) /
                              100
                            }}
                            {{ item.sourceData.unit }}
                          </span>
                          ({{ item.action }} {{ item.reductionPercentage }}% by
                          {{ item.due_at.split("-")[0] }})
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-card>
                </template>
              </q-virtual-scroll>
              <!--GRID VIEW-->
              <q-scroll-area
                v-else
                style="height: calc(100vh - 285px)"
                :thumb-style="{
                  background: '#162c479c',
                  opacity: 1,
                  width: '8px',
                  height: '8px',
                  borderRadius: '20px',
                }"
                class="full-width"
              >
                <div class="row justify-center">
                  <div
                    v-for="(goal, i) in formattedGoals"
                    :key="i"
                    style="width: 218px"
                    class="q-ma-sm"
                    @click="selectGoal(goal, i)"
                  >
                    <q-card
                      v-ripple
                      clickable
                      style="
                        height: 210px;
                        width: 218px;
                        border-radius: 0px;
                        background-color: #f6f6f6;
                      "
                      flat
                    >
                      <div v-if="goal.basicGoals_id">
                        <!--PRE WRITTED GOAL/BASIC GOAL/SUGGESTED GOAL (FORMAT)-->
                        <div
                          v-if="!goal.basicGoalImageUrl"
                          style="
                            height: 145px;
                            width: 218px;
                            background-color: grey;
                          "
                        >
                          <div class="row justify-end">
                            <q-checkbox
                              dark
                              v-model="goal.selected"
                              color="accent"
                            >
                            </q-checkbox>
                          </div>
                        </div>
                        <q-img
                          v-else
                          style="height: 145px; width: 218px"
                          :src="goal.basicGoalImageUrl"
                        >
                          <div
                            class="row justify-end"
                            style="
                              width: 100%;
                              padding: 0px !important;
                              background: rgba(0, 0, 0, 0);
                            "
                          >
                            <q-checkbox
                              dark
                              v-model="goal.selected"
                              color="accent"
                              @input="selectGoal(goal, i)"
                            >
                            </q-checkbox>
                          </div>
                        </q-img>
                        <div
                          class="goalItemCard_text q-px-xs row items-center"
                          style="height: 60px"
                        >
                          <div>
                            <span
                              v-if="formatPreWrittenGoalText(goal).reversed"
                              class="goalItem_source_text text-bold"
                            >
                              {{ formatPreWrittenGoalText(goal).coloredText }}
                            </span>
                            {{ formatPreWrittenGoalText(goal).normalText }}
                            <span
                              v-if="!formatPreWrittenGoalText(goal).reversed"
                              class="goalItem_source_text text-bold"
                            >
                              {{ formatPreWrittenGoalText(goal).coloredText }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="!goal.writeYourOwnGoal && goal.sourceData"
                      >
                        <!--GOAL BUILDER (FORMAT)-->
                        <div
                          v-if="!goal.sourceData.imageUrl"
                          style="
                            height: 145px;
                            width: 218px;
                            background-color: grey;
                          "
                        >
                          <div class="row justify-end">
                            <q-checkbox
                              dark
                              v-model="goal.selected"
                              color="accent"
                            >
                            </q-checkbox>
                          </div>
                        </div>
                        <q-img
                          v-else
                          style="height: 145px; width: 218px"
                          :src="goal.sourceData.imageUrl"
                        >
                          <div
                            class="row justify-end"
                            style="
                              width: 100%;
                              padding: 0px !important;
                              background: rgba(0, 0, 0, 0);
                            "
                          >
                            <q-checkbox
                              dark
                              v-model="goal.selected"
                              color="accent"
                              @input="selectGoal(goal, i)"
                            >
                            </q-checkbox>
                          </div>
                        </q-img>

                        <div
                          class="goalItemCard_text q-px-xs row items-center"
                          style="height: 60px"
                        >
                          <div>
                            {{
                              goal.action == "Reduce" ? "Reduction" : "Increase"
                            }}
                            of
                            <span class="goalItem_source_text text-bold">
                              {{ goal.sourceData.name }}
                            </span>
                            by
                            <span class="goalItem_source_text text-bold">
                              {{
                                (goal.baselineData * goal.reductionPercentage) /
                                100
                              }}
                              {{ goal.sourceData.unit }}
                            </span>
                            ({{ goal.action }} {{ goal.reductionPercentage }}%
                            by {{ goal.due_at.split("-")[0] }})
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <!--WRITE YOUR OWN GOAL (FORMAT)-->
                        <q-img
                          v-if="goal.customImgUrl"
                          style="height: 145px; width: 218px"
                          :src="goal.customImgUrl"
                        >
                          <div
                            class="row justify-end"
                            style="
                              width: 100%;
                              padding: 0px !important;
                              background: rgba(0, 0, 0, 0);
                            "
                          >
                            <q-checkbox
                              dark
                              v-model="goal.selected"
                              color="accent"
                              @input="selectGoal(goal, i)"
                            >
                            </q-checkbox>
                          </div>
                        </q-img>
                        <div
                          v-else-if="!selectedOutcome.imageUrl"
                          style="
                            height: 145px;
                            width: 218px;
                            background-color: grey;
                          "
                        >
                          <div class="row justify-end">
                            <q-checkbox
                              dark
                              v-model="goal.selected"
                              color="accent"
                            >
                            </q-checkbox>
                          </div>
                        </div>
                        <q-img
                          v-else
                          style="height: 145px; width: 218px"
                          :src="selectedOutcome.imageUrl"
                        >
                          <div
                            class="row justify-end"
                            style="
                              width: 100%;
                              padding: 0px !important;
                              background: rgba(0, 0, 0, 0);
                            "
                          >
                            <q-checkbox
                              dark
                              v-model="goal.selected"
                              color="accent"
                              @input="selectGoal(goal, i)"
                            >
                            </q-checkbox>
                          </div>
                        </q-img>
                        <div
                          class="goalItemCard_text q-px-xs row items-center"
                          style="height: 60px"
                        >
                          <span class="goalItem_source_text text-bold">
                            {{ goal.writeYourOwnGoal }}
                          </span>
                        </div>
                      </div>
                    </q-card>
                  </div>
                </div>
              </q-scroll-area>
            </div>
            <div class="row justify-between q-mt-sm">
              <div>
                <q-btn
                  class="q-px-sm q-py-xs text-white bg-secondary q-mr-xs"
                  flat
                  no-caps
                  @click="$router.push(`/outcomePlans/outcome/${selectedOutcomeModel.id}/goalSummary`)"
                  >
<!--                  @click="-->
<!--                    selectedOutcome.dataAssessmentTool-->
<!--                      ? $router.push(-->
<!--                          `/outcomePlans/outcome/${selectedOutcomeModel.id}/goalSummary`-->
<!--                        )-->
<!--                      : $router.push(-->
<!--                          `/outcomePlans/outcome/${selectedOutcome.id}/scaleSummary`-->
<!--                        )-->
<!--                  "-->
                  Back
                </q-btn>
                <q-btn
                  class="q-px-sm q-py-xs text-white q-ml-xs"
                  :style="`background: ${cssVars['--outcome-secondary']}`"
                  flat
                  no-caps
                  @click="addNewGoal"
                >
                  Add New Goal
                </q-btn>
                <q-btn
                  class="q-px-sm q-py-xs q-ml-sm"
                  flat
                  no-caps
                  @click="updateSelectedGoal(null)"
                >
                  Edit Selected Goal
                </q-btn>
              </div>
              <div>
                <div class="row items-end items-center">
                  <!-- <div class="pagination">
                    <span class="text-bold text-accent"
                      >Page {{ currentPage }}
                    </span>
                    <span class="text-accent"> - {{ maxPage }} </span>
                    of {{ formattedGoals.length }} Results
                  </div> -->
                  <!-- <div>
                    <q-btn
                      flat
                      round
                      icon="fas fa-chevron-left"
                      size="sm"
                      :disable="isMinPage"
                      :color="isMinPage ? 'grey-5' : 'accent'"
                      @click="nextPage(false)"
                    >
                    </q-btn>
                    <q-btn
                      flat
                      round
                      icon="fas fa-chevron-right"
                      size="sm"
                      :color="isMaxPage ? 'grey-5' : 'accent'"
                      :disable="isMaxPage"
                      class="q-ml-sm"
                      @click="nextPage(true)"
                    >
                    </q-btn>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 25%">
          <side-bar class="sidebar_wrapper" style="height: calc(100vh - 60px)">
            <div class="column full-height full-width sidebar">
              <div class="col-auto q-px-lg" style="height: calc(109px)">
                <div class="row full-height items-center">
                  <span class="goalSummary-title" style="margin-bottom: 40px">
                    {{
                      selectedGoalIndex != null ||
                      selectedGoalIndex != undefined
                        ? "Goal Summary"
                        : "Setting Goals"
                    }}
                  </span>
                </div>
              </div>
              <div class="col-auto q-pa-lg" style="height: calc(100vh - 226px)">
                <div
                  v-if="
                    (selectedGoalIndex != null ||
                      selectedGoalIndex != undefined) &&
                    formattedGoals[selectedGoalIndex].sourceData
                  "
                  class="col-12"
                >
                  <div class="row">
                    <span class="title"
                      >{{
                        formattedGoals[selectedGoalIndex].action == "Reduce"
                          ? "Reduce"
                          : "Increase"
                      }}
                      use of</span
                    >
                  </div>
                  <div class="row">
                    <span class="goal-title">
                      {{ formattedGoals[selectedGoalIndex].sourceData.name }}
                    </span>
                  </div>
                  <div class="row">
                    <span class="title">by</span>
                  </div>
                  <div class="row">
                    <span class="goal-title">
                      {{
                        (formattedGoals[selectedGoalIndex].baselineData *
                          formattedGoals[selectedGoalIndex]
                            .reductionPercentage) /
                        100
                      }}
                      {{ formattedGoals[selectedGoalIndex].sourceData.unit }}
                    </span>
                  </div>
                  <div class="row">
                    {{ formattedGoals[selectedGoalIndex].action }} by
                    {{ formattedGoals[selectedGoalIndex].reductionPercentage }}%
                  </div>
                  <div class="row">
                    <span class="title"
                      >before the end of
                      {{
                        formattedGoals[selectedGoalIndex].due_at.split("-")[0]
                      }}</span
                    >
                  </div>
                </div>
                <div
                  v-else-if="
                    (selectedGoalIndex != null ||
                      selectedGoalIndex != undefined) &&
                    formattedGoals[selectedGoalIndex].basicGoalAction
                  "
                  class="col-12"
                >
                  <div class="row">
                    <span class="title"> Pre-written Goal </span>
                  </div>
                  <div class="row">
                    <span class="goal-title">
                      {{ formattedGoals[selectedGoalIndex].basicGoalAction }}
                    </span>
                  </div>
                </div>
                <div v-else class="col-12">
                  Welcome to <b class="highlight">Setting Goals</b>, here is
                  where you will be able to create various types of goals to
                  help you with your outcome plan. <br />
                  <br />
                  <i class="q-my-md actionNote"
                    >Click on "Add a Goal" to reveal a range of options to
                    create a goal</i
                  >
                </div>
              </div>
              <div class="col q-px-md">
                <q-btn
                  :style="`background: ${cssVars['--outcome-secondary']}`"
                  class="q-px-sm q-py-xs grid_buttons_new float-right"
                  no-caps
                  flat
                  @click="
                    $router.push(
                      `/outcomePlans/outcome/${selectedOutcomeModel.id}/solutionWelder`
                    )
                  "
                >
                  <span class="button-next-steps text-white"> Next </span>
                </q-btn>
              </div>
            </div>
          </side-bar>
        </div>
      </div>
    </div>
    <q-dialog v-model="overallTargetSelectorDialog">
      <set-overall-target-form
        :outcome="selectedOutcome"
        assessment-tool="data"
        :close-function="
          () => {
            overallTargetSelectorDialog = false;
          }
        "
      >
      </set-overall-target-form>
    </q-dialog>
    <q-dialog v-model="goalBuilderDialog" persistent>
      <workspace-goal-builder
        :outcomeColor="selectedOutcome.primaryColor"
        :selectedOutcome="selectedOutcome"
        @closeDialog="closeGoalBuilderDialog"
        @callGoalSummaryInit="initGoals"
      ></workspace-goal-builder>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import sustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";
import sustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import Topbar from "@/components/topbar/topbar.vue";
import WorkspaceGoalBuilder from "@/components/goalBuilder/workspaceGoalBuilder/workspaceGoalBuilder.vue";
import SideBar from "@/components/sidebar/sidebar.vue";
import SummaryStatsCard from "@/components/generalComponents/summaryStatsCard";
import SetOverallTargetForm from "@/components/businessTargets/SetOverallTargetForm";

export default {
  data: () => ({
    outcomeDropdown: false,

    //grid options
    selected: [],
    sortByDropdown: "Newest",
    sortByDropdownOptions: ["Newest", "Oldest"],
    grid: true,

    formattedGoals: [],
    selectedGoalIndex: null,
    goalBuilderDialog: false,

    //pagination
    itemsPerPage: 20,
    currentPage: 1,

    //solutions
    selectedSolutions: [],

    //  Overall Target
    overallTargetSelectorDialog: false,
  }),
  watch: {
    $route: {
      handler(value) {
        this.handleRoute();
      },
      deep: true,
    },
  },
  components: {
    sustainabilityDataTable,
    sustainabilityDropdown,
    Topbar,
    WorkspaceGoalBuilder,
    SideBar,
    SummaryStatsCard,
    SetOverallTargetForm,
  },
  computed: {
    ...mapGetters({
      currentUserData: "auth/currentUserData",
      outcomesList: "outcomes/list",
      solutionsList: "solutions/sources/list",
      selectedOutcome: "general/selectedOutcome",
      goals: "goals/list",
      businessExtra: "businessExtra/data",
      businessTargets: "businessTargets/list",
    }),
    summaryStatsCardSlides() {
      // This is deciding what Unit to use (If there is an override on the outcome or not.)
      // let unit = this.selectedOutcome.factorUnitDisplay
      //   ? this.selectedOutcome.factorUnitDisplay
      //   : this.filteredData[0]
      //     ? this.filteredData[0].emissionsFactor[0].unit
      //     : "";
      // let factorMultiplier = this.selectedOutcome.factorMultiplier
      //   ? this.selectedOutcome.factorMultiplier
      //   : 1;
      // let intensity =
      //   this.businessExtra && this.businessExtra.annualRevenue
      //     ? (
      //       (this.calculateTotalEmissionsBasedOnData * factorMultiplier) /
      //       (this.businessExtra.annualRevenue / 1000000)
      //     ).toFixed(2)
      //     : 0;

      let businessTargetContent =
        this.businessTargets && this.businessTargets.data
          ? `From <b>${this.$options.filters.numberFormat(
              this.businessTargets.data.baseLineData
            )} ${this.factorUnit(
              this.businessTargets.data.baseLineUnit
            )}</b> <br /> to <b>${this.$options.filters.numberFormat(
              this.businessTargets.data.targetData
            )} ${this.factorUnit(this.businessTargets.data.baseLineUnit)}</b>`
          : `Please Set an Overall Target for ${this.selectedOutcome.label}`;
      let businessReduceContent =
        this.businessTargets && this.businessTargets.data
          ? `Reduce by ${
              this.businessTargets.data.reducePercent
            }% (${this.$options.filters.numberFormat(
              this.businessTargets.data.baseLineData -
                this.businessTargets.data.targetData
            )} ${this.factorUnit(this.businessTargets.data.baseLineUnit)})`
          : ``;
      let slides = [
        // {
        //   cardTitle: `${this.selectedOutcome.label} (${unit})`,
        //   cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${(
        //     this.calculateTotalEmissionsBasedOnData * factorMultiplier
        //   ).toFixed(
        //     2
        //   )} <span style='font-size: 14px; font-weight: 800'>(${unit})</span></h3>`,
        //   subContent: `<span style='color: ${this.cssVars["--outcome-primary"]}'>based on your current data entries</span>`,
        //   action: {
        //     emit: "setOverallTarget",
        //     text: true,
        //     underlined: true,
        //     label: "Set Target",
        //   },
        // },
        {
          cardTitle: `Your Overall Target`,
          cardMainContent: `<h3 class='q-ma-none' style='font-size: 1rem; line-height: 1.0rem; font-weight: 400; margin: 0'>
                                                                                                  ${businessTargetContent}
                                                                                                    `,
          subContent: `<span style='color: ${this.cssVars["--outcome-primary"]}'>${businessReduceContent}</span>`,
          action: {
            emit: "setOverallTarget",
            text: true,
            underlined: true,
            label: "Set Target",
          },
        },
        // {
        //   cardTitle: `Your ${this.selectedOutcome.label} Intensity`,
        //   cardMainContent: `<h3 class='q-ma-none' style='font-size: 20px; line-height: 25px; font-weight: 800; margin: 0'>${intensity} <span style='font-size: 14px; font-weight: 800'>${unit}/$1M</span></h3>`,
        //   subContent: `<span style='color: ${
        //     this.cssVars["--outcome-primary"]
        //   }'>based on $${this.$options.filters.numberFormat(
        //     this.businessExtra.annualRevenue
        //   )} gross revenue</span>`,
        //   action: {
        //     emit: "setOverallTarget",
        //     text: true,
        //     underlined: true,
        //     label: "Set Target",
        //   },
        // },
      ];
      return slides;
    },
    selectedOutcomeModel: {
      set(newValue) {
        this.selectOutcome(newValue);
      },
      get() {
        return this.selectedOutcome;
      },
    },
    columns() {
      return [
        {
          name: "title",
          label: "title",
          align: "left",
          field: "source",
        },
      ];
    },
    cssVars() {
      let primaryColorFaded = this.selectedOutcome.primaryColor
        ? this.selectedOutcome.primaryColor.split("#")
        : ["", "162c47"];
      let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
      return {
        "--outcome-primary": this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor
          : "#162c47",
        "--outcome-secondary": this.selectedOutcome.secondaryColor
          ? this.selectedOutcome.secondaryColor
          : "#162c47",
        "--outcome-tertiary": this.selectedOutcome.tertiaryColor
          ? this.selectedOutcome.tertiaryColor
          : "#162c47",
        "--outcome-primary-faded": primaryColorFadedString,
      };
    },
    maxPage() {
      return Math.ceil(this.formattedGoals.length / this.itemsPerPage);
    },
    isMaxPage() {
      if (
        this.currentPage ==
        Math.ceil(this.formattedGoals.length / this.itemsPerPage)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isMinPage() {
      if (this.currentPage == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    initSolutionsList(sources_id) {
      this.selectedSolutions = [];
    },
    onSolutionSelect(solution) {
      let index = this.selectedSolutions.findIndex((e) => solution.id == e.id);
      if (index > -1) {
        this.selectedSolutions.splice(index, 1);
      } else {
        this.selectedSolutions.push(solution);
      }
    },
    setOverallTarget() {
      this.overallTargetSelectorDialog = true;
    },
    async addSolutionsToPlan() {
      if (this.selectedSolutions.length > 0) {
        let result = await this.$store.dispatch(
          "solutions/business/newMass",
          this.selectedSolutions
        );

        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.initSolutionsList(
            this.formattedGoals[this.selectedGoalIndex].sources_id
          );
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },
    async removeSolution(solution) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = {
            solutions_id: solution.id,
            id: solution.solutionsBusiness_id,
            deleted_at: true,
          };
          let result = await this.$store.dispatch(
            "solutions/business/removeSolution",
            payload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.initSolutionsList(
              this.formattedGoals[this.selectedGoalIndex].sources_id
            );
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      });
    },
    handleRoute() {
      if (this.$route.params.hasOwnProperty("goalID")) {
        this.goalBuilderDialog = true;
      } else if (this.$route.params.hasOwnProperty("outcomesID")) {
        this.initGoals();
      }
    },
    updateSelectedGoal() {
      if (
        this.selectedGoalIndex != null ||
        this.selectedGoalIndex != undefined
      ) {
        const selectedGoal = this.formattedGoals[this.selectedGoalIndex];
        this.$router.push(this.$route.path + "/goal/" + selectedGoal.id);
      }
    },
    formatPreWrittenGoalText(goal) {
      console.log(goal);
      // TODO: This is a really weird way it of doing this, should be re-written, works for now but could break in the future
      if (goal.basicGoalAction) {
        let normalText = goal.basicGoalAction.split(goal.basicGoal);

        if (normalText.length > 0 && normalText[0]) {
          let coloredText = goal.basicGoalAction.split(normalText[0]);
          return {
            normalText: normalText[0],
            coloredText: coloredText[1],
          };
        }

        if (normalText.length > 1 && normalText[1]) {
          return {
            coloredText: goal.basicGoal,
            normalText: normalText[1],
            reversed: true,
          };
        }
      } else {
        return {
          normalText: goal.basicGoal,
          coloredText: "",
        };
      }
      let normalText = goal.basicGoalAction.split(goal.basicGoal);

      if (normalText.length > 0) {
        let coloredText = goal.basicGoalAction.split(normalText[0]);
        return {
          normalText: normalText[0],
          coloredText: coloredText[1],
        };
      }
    },
    closeGoalBuilderDialog() {
      if (this.$route.params.hasOwnProperty("goalID")) {
        this.$router.push("/workspace/" + this.selectedOutcome.id);
        this.selectedGoalIndex = null;
      }
      this.goalBuilderDialog = false;
    },
    selectOutcome(outcome) {
      this.selectedGoalIndex = null;
      this.$router.push("/workspace/" + outcome.id);
      this.$store.commit("general/setSelectedOutcome", outcome);
    },
    addNewGoal() {
      this.goalBuilderDialog = true;
    },
    selectGoal(goal, index) {
      if (this.selectedGoalIndex == index) {
        this.formattedGoals[index].selected = false;
        this.selectedGoalIndex = null;
      } else {
        let goals = [];
        this.formattedGoals.forEach((e) => {
          if (goal.id == e.id) {
            goals.push({ ...e, selected: true });
          } else {
            goals.push({ ...e, selected: false });
          }
        });
        this.formattedGoals = goals;
        this.selectedGoalIndex = index;
      }
    },
    initGoals() {
      this.formattedGoals = [];
      this.$store
        .dispatch(
          "goals/loadAllGoalsAndBasicGoalsByOutcomeID",
          this.selectedOutcomeModel.id
        )
        .then(() => {
          this.formattedGoals = [];
          this.goals.forEach((e) => {
            this.formattedGoals.push({ ...e, selected: false });
          });
          this.filterGoals();
        });
    },
    getWhiteOutcomeImage: getWhiteOutcomeImage,
    filterGoals() {
      let goals = this.formattedGoals;
      if (this.sortByDropdown == "Newest") {
        goals.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));
      } else {
        goals.sort((a, b) => (a.created_at > b.created_at ? 1 : -1));
      }
      this.formattedGoals = goals;
    },
    init() {
      this.$store.dispatch("outcomes/loadAll").then((e) => {
        let outcome = this.outcomesList.find(
          (outcome) => outcome.id == this.$route.params.outcomesID
        );
        this.$store.dispatch("general/updateSelectedOutcome", outcome);
        this.handleRoute();
      });
    },
    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
    nextPage(isNext) {
      if (isNext) {
        if (
          this.currentPage <
          Math.ceil(this.formattedGoals.length / this.itemsPerPage)
        ) {
          this.currentPage = this.currentPage + 1;
        }
      } else {
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
        }
      }
    },
    async deleteSelectedGoal() {
      let res = await this.$swal({
        title: "Warning",
        text: "You are about to delete this goal, this is irreversible. Are you sure you want to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      });

      if (res.value) {
        let payload = { id: this.formattedGoals[this.selectedGoalIndex].id };

        let response = await this.$store.dispatch("goals/delete", payload);
        if (response.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: "The Goal Goal has been removed from your plan.",
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }

        this.selectedGoalIndex = null;
        this.initGoals();
      }
    },
    factorCalculation(data) {
      if (this.selectedOutcome && this.selectedOutcome.factorMultiplier) {
        return data * this.selectedOutcome.factorMultiplier;
      } else {
        return data;
      }
    },

    factorUnit(data) {
      if (this.selectedOutcome && this.selectedOutcome.factorUnitDisplay) {
        return this.selectedOutcome.factorUnitDisplay;
      } else {
        return data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdownTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

.gridOptions_text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14.6054px;
  line-height: 14px;
}

.grid_buttons_edit {
  color: var(--outcome-primary) !important;
  background-color: #f6f6f6;
  height: 40px;
  width: 133px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
}

.goalItem_text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}

.goalItem_source_text {
  color: var(--outcome-primary);
}

.goalItemCard_text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10.2632px;
}

.sidebar_wrapper {
  background-color: #f6f6f6;
  font-family: "Montserrat";
  font-style: normal;

  .goalSummary-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    color: var(--outcome-secondary);
  }

  .highlight {
    color: var(--outcome-secondary);
  }

  .actionNote {
    font-size: 0.7rem;
  }

  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
  }

  .title2 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 10.1305px;
  }

  .goal-title {
    font-family: "Montserrat";
    font-style: normal;
    font-size: 20.5369px;
    font-weight: 900;
    color: var(--outcome-primary);
  }

  .emissionsFactorText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
  }
}
</style>
